module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_c('span', {
    staticClass: "cn-b"
  }, [_vm._v("PROPOSITION 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_vm._v("History Is Not One Damn Thing after Another")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("SUMMARY")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A first step in finding a politic which is “neither right nor left nor religious” is construing "), _c('i', [_vm._v("history")]), _vm._v(" correctly. For some, “history is just one damn thing after another.” This famed phrase well depicts those who believe history has no meaning, no direction or goal, no ultimate purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Many Christians also think this: “It’s all going to burn, and none of this matters.” What matters, they say, is the human soul “going to heaven when we die.” No need to concern ourselves with troubling social or political matters because “God’s got this.” Politics and social affairs are of no concern to the faithful.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Many Jews, Muslims, and Christians know better. Some prominent early Christians, in fact, believed such spiritualizing to be a grave heresy that would destroy the Christian faith. They saw human history as the stage for the unfolding of the drama of God’s work. In this drama God was assured to be the victor, even if God’s ways are often inscrutable, even exasperating to those who love God. This God who had created a good creation would restore it, redeem it, save it. This God would set right the injustice and violence, remove the arrogant mighty ones from their throne rooms and White Houses, fill up the hungry, and bind up the oppressed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this drama some humans, feeble and petty as they may "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("be, ally themselves for the work of God. Meanwhile, many of the preening, arrogant powers array themselves against both God and humankind. Those arrogant powers often serve as the handmaidens of death, while the God of life keeps intruding, or so it appears to the powers, bringing light into the darkness.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("But human history is not one damn meaningless thing after another, even if the horror of the mundane evil propagated by the powers tempts us to despair. History has a "), _c('i', [_vm._v("goal")]), _vm._v(", a direction toward a climax: the author of life shall write a tale, has written a tale, in which all lies and greed and ugliness and war; prisons and lusts, oppression and hate; hostility, disease, contempt, and envy; all shall be undone and set right, and there shall come a triumph of truth and goodness and beauty, which no ear has yet heard, and no eye has yet seen.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("EXPOSITION")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('i', [_vm._v("The Scream")]), _vm._v(" has been called the "), _c('i', [_vm._v("Mona Lisa")]), _vm._v(" of the twentieth century. Edvard Munch’s iconic painting arose from a dreadful vision he had one day at sunset. Walking along a fjord in his native Norway, he said he “sensed an infinite scream passing through nature.” That scream captures the modern sense of despair, in which no hope remains, only anxiety, loneliness, and despondency.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Munch’s artistic angst illustrates well some common philosophical convictions about history: that history has no direction or is merely an endless cycle of repetition or is but one damn meaningless thing after another. There are also religions, supposedly Christian versions of such, that think that human history is ultimately unimportant. These alleged Christian versions postulate some hope, some purpose, but it is a purpose beyond history, outside of history. It is a reward “up there,” souls floating off to heaven. “Our true home,” they say, “is in heaven. We need not concern ourselves with social or political or historical matters.” ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("One therapeutic solution to Munch’s "), _c('i', [_vm._v("Scream")]), _vm._v(" is simply not to look too closely at history, not get ourselves involved in matters that don’t concern us in our spiritual contentment. If you don’t pay attention to the death camps or the brokenness of the cities or ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("the systemic greed undergirding our economies, then you need not feel the despair. You simply ignore it, look beyond, to the sweet by-and-by.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Edvard Munch, "), _c('i', [_vm._v("The Scream,")]), _vm._v(" 1893, oil, tempera, and pastel on cardboard, 91 x 73 cm, National Gallery of Norway.")]), _vm._v(" "), _c('i', [_vm._v("Wikimedia Commons")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("This is Marx’s classical critique: religion as the opiate of the masses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But as much biblical scholarship has been contending of late, “going to heaven” is "), _c('i', [_vm._v("not")]), _vm._v(" the point of the New Testament, nor did early Christians believe it so.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Along with recent biblical scholarship, the poets and prophets and song-singers have always known better. The Hebrew prophets envisioned a day in which “the lamb shall lie down with the lion,” “the nations shall learn war no more,” and “swords shall be beaten into plowshares.” The poets and lyricists of our own day insist that “a change is gonna come” and that we “still haven’t found what [we’re] looking for.” And Martin Luther King Jr. proclaimed that he had a dream and that “the arc of history is long, but it bends toward justice.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("All these poetic utterances point us toward hopefulness. Each assumes that history is not, in the final analysis, a meaningless morass of vanity. Instead, history has a direction: injustice undone, brokenness bound up, captivity taken captive. This is the goal of history, the end of history. We need not confuse “end of history” with the termination of time; it is, rather, best considered as the final goal toward which all things are moving."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Historic Christianity insists precisely this: that history is headed toward a glorious re-creation the likes of which only poets can begin to voice.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This conviction is a most significant starting point for considering a sociopolitical vision for Christian practice.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Hope as an Interpretation of History")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This idea—a goal of history—entails the notion of "), _c('i', [_vm._v("hope")]), _vm._v(".")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("This is where the American myth and Christian teaching have a high degree of overlap: both assert the notion of a direction to history and thus the practical importance of "), _c('i', [_vm._v("hope")]), _vm._v(". There is similar overlap with the secularist who speaks of progress, assuming some direction in human history."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(" As the philosopher John Gray describes John Stuart Mill, one of the preeminent philosophers of the liberal tradition in the West: “he founded an orthodoxy—the belief in improvement that is the unthinking faith of people who think they have no religion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If it is true that Christianity does proclaim that history matters and is going somewhere, then it turns out that many American and secularist forms of hope are "), _c('i', [_vm._v("more Christian")]), _vm._v(" than the otherworldly dreams of some Christians. Or, at a minimum, we can say that such Americans and secularists are more Christian in their conviction regarding the immeasurable worth of the whole of human history.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When Americans and secularists insist that history "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("matters—that social policy and scientific concern for the earth "), _c('i', [_vm._v("matter")]), _vm._v(", that economic policy and staggering disparities in wealth "), _c('i', [_vm._v("matter")]), _vm._v(", that the industrialization of war and imprisonment for profit "), _c('i', [_vm._v("matter")]), _vm._v("—they show themselves, in this regard, more Christian than many Christians.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The hope of heaven, in other words, too easily becomes an "), _c('i', [_vm._v("ahistorical")]), _vm._v(" hope, a hope that cares nothing for the unfolding of the human drama, except perhaps to hope that sufficient religious or moral choices are rightly made so that the soul can sweep through the Pearly Gates.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("In this way, "), _c('i', [_vm._v("some American revivalists may have done more to undermine Christianity in America than the secularists")]), _vm._v(" by making the locus of Christianity the individual’s judgment before the throne of God, a religion that has little to say to the teeming and throbbing pain of human history and instead calls us to cast our vision to an afterlife removed from care for human history or for God’s good creation. Such a tendency contributed to Malcolm X renouncing Christianity and embracing Islam. “The white man has taught us to shout and sing and pray until we die, to wait until "), _c('i', [_vm._v("death")]), _vm._v(", for some dreamy heaven-in-the-hereafter, when we’re "), _c('i', [_vm._v("dead")]), _vm._v(", while this white man has milk and honey in the streets paved with golden dollars right here on "), _c('i', [_vm._v("this")]), _vm._v(" earth!”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One of the failings of the secularist notion of progress is its vague lack of content: What does progress entail? What does it look like? What is its content?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Similarly, the Christian notion of hope must attend to these same questions. The biblical creation account, in which Jews and Christians maintain that the creation itself is "), _c('i', [_vm._v("good")]), _vm._v(", is indispensable in beginning to answer such questions. The Genesis account about creation is not a sort of crypto-scientific description best read as a literal account of the unfolding of the cosmos. Instead, the Genesis account insists on the moral and aesthetic goodness of the creation grounded and rooted in the "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("abundant generosity of God. It presumes a community inherent in the very nature of God and that this self-giving God invited all creation, and humankind in a special way, to participate in the joyous work of tilling and cultivating in the unfolding story of the garden of God.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("And yet death and death’s handmaidens duped the humans, vandalizing the abode of God and humankind. And yet more, this God who is good and patient and long-suffering did not leave humankind to its own devices but would act in love and power and justice to set things right—while still honoring humankind’s radical freedom to reject the good ways of God—to free humankind from the bondage in which it found itself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“New heavens and new earth”—that’s what one of the prophets called the greatly anticipated redemption of God. Christianity was not concerned first and foremost with some realm of disembodied spirits beyond the pale of human history.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Consider the stunning objection of one of the early church martyrs, Justin. He was arrested and beheaded for his faith. His commentary is striking. There are some “who are called Christians,” he said rather derisively, who insisted that “their souls, when they die, are taken to heaven.” He classified such people among “godless, impious heretics.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is an ironic, odd reality: that an early defender of Christianity who refused to submit to the demands of the Roman Empire, who insisted that Jesus was Lord, and who was executed for his stance, would say that our American Joe Christian is not in fact a Christian but a heretic. Justin was not executed because he was religious. He was executed because he held to a competing interpretation of human history. Justin held to an alternative politic that entailed that the Word of God revealed in this Jesus of Nazareth was the only rational explanation that made sense of our lives and was the only rational ground for hope. The resurrecting power of "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("God which had raised this Jesus from the dead would not only raise all of us but also make new the heavens and the earth and set all things right.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Jesus and other early Christians were not executed because they were spiritual. They were executed because their politic was a threat to the powers that be.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Content of the Hope")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is not the afterlife for which the prophet longs but the setting right of this life: the pain of lost loves and the death of infants, of old griefs and deep regret, of the weeping of mothers or the cries of war. All shall be wrought up into the work of this God who shall wipe away every tear from every eye and make all things right.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hear, for example, the Hebrew prophet Isaiah:")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("For I am about to create new heavens")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("and a new earth;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("the former things shall not be remembered")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("or come to mind.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("But be glad and rejoice forever")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("in what I am creating;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("for I am about to create Jerusalem as a joy,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("and its people as a delight.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("I will rejoice in Jerusalem,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("and delight in my people;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("no more shall the sound of weeping be heard in it,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("or the cry of distress.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("No more shall there be in it")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("an infant that lives but a few days,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("or an old person who does not live out a lifetime;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("for one who dies at a hundred years will be considered a youth,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("and one who falls short of a hundred will be considered accursed.")])]), _c('p', {
    staticClass: "PM"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("They shall build houses and inhabit them;")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "PMi"
  }, [_vm._v("they shall plant vineyards and eat their fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("They shall not build and another inhabit;")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("they shall not plant and another eat;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("for like the days of a tree shall the days of my people be,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("and my chosen shall long enjoy the work of their hands.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("They shall not labor in vain,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("or bear children for calamity;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("for they shall be offspring blessed by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("and their descendants as well.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Before they call I will answer,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("while they are yet speaking I will hear.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("The wolf and the lamb shall feed together,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("the lion shall eat straw like the ox;")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("but the serpent—its food shall be dust!")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("They shall not hurt or destroy")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("on all my holy mountain,")]), _vm._v(" "), _c('p', {
    staticClass: "PMi"
  }, [_vm._v("says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(". (Isa. 65:17–25)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A great abundance of many of the finest lines of poetry inscribed in human history is grasping after, longing after, painting a glimpse of this coming hope. The street of gold, God wiping every tear from every eye, the great river that flows from the throne of God lined on both banks with the very tree of life—all these poetic images of the triumph of God—are "), _c('i', [_vm._v("not depicted in heaven")]), _vm._v(" in the biblical text. Instead, Revelation 21–22 depict such glory occurring "), _c('i', [_vm._v("here")]), _vm._v(", even here in the midst of human history, even here in the midst of us. Oppression shall be undone, infidelity cast out, captivity itself taken captive, not in the sweet by-and-by but in the climax of the story of God in our midst.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The biblical vision, then, will countenance no supposed withdrawal from politics. The prophets will hear none of this religious pretending that history does not matter, all in the name of a pietistic assertion that “God’s got this.” The biblical texts refuse to minimize the importance of social and historical developments, will not look the other way as the scoundrels of death vandalize ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("and terrorize, will not let us look away from the bitter cries of mothers, the lonely privation of old men, the needless deaths of children.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("No! “Captivity has been taken captive.” “Let my people go!” “Let justice roll down like waters, and righteousness like an ever-flowing stream.” “Do justice, love mercy, and walk humbly with God!”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The great paradigmatic moment of political encounter in the founding narrative of the Christians comes with the gospel: “Change, and believe in the good news of the reign of God.” This new political movement of God would entail specific practices unlike those of the nations, unlike those of the powers whom we have falsely assumed have the monopoly on political power. This new political movement would offer the world something at which kings and rulers would shake their heads: love of enemies, practices of reconciliation, sharing of wealth, honoring of marriage, renunciation of our varied practices of greed and lust, and an embrace of all the practices of life and mercy and kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Or thus said Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In all these and many compelling ways besides, the Scriptures call us to face the pain and brokenness of human history.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("And we are called to have the courage to play our part: to be brave as the soldier, committed as the activist, devoted as the evangelical, sedulous as the journalist—speaking to, acting for, sowing the seeds of the world that is on its way, knowing that it requires great labor, perseverance, and a willingness to suffer, and promises, too, on the journey, of deep joy and gladness, friends and fellow pilgrims, called as we are to be bearers of the end of history. We shall refuse to vindicate Marx by refusing to let our faith be an opiate of the masses; we shall face the pain and oppression squarely and proclaim the good news that the hope of all humankind, evoked in and out of our tears and cries and confusion and anger, has come, shall come. And we shall dare to live by it.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("So: No, history is not one damn meaningless thing after another. Moses, the prophets, and Jesus, each in their own way, insisted that history has a goal, a direction, an intrinsic and inescapable importance in the purposes of the Creator of all things good. And woe be unto those who stand in the way of this great God’s unfolding of this narrative, which will not be stopped until all that is beautiful and good and true is made manifest in our midst.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". A great deal of work is currently being done in the West on how to make sense of the Christian doctrine of original sin given the now-pervasive acceptance of the theory of evolution and the rise of the human species by means of natural selection. Much of this work appears fruitful. It is not as clear to me that similar work is being done with regard to Christian eschatological teaching, given new insights in cosmology and theories of relativity and the like, but this seems needful as well.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". In his typical provocative and insightful fashion, Andrew Sullivan notes that we all have a “religion” these days, even the atheists, in some attenuated fashion, and he explicitly draws the parallel between Christian faith and the secularist progress myth: “Seduced by scientism, distracted by materialism, insulated, like no humans before us, from the vicissitudes of sickness and the ubiquity of early death, the post-Christian West believes instead in something we have called progress—a gradual ascent of mankind toward reason, peace, and prosperity—as a substitute in many ways for our previous monotheism. We have constructed a capitalist system that turns individual selfishness into a collective asset and showers us with earthly goods; we have leveraged science for our own health and comfort. Our ability to extend this material bonanza to more and more people is how we define progress; and progress is what we call meaning.” Andrew Sullivan, “America’s New Religions,” "), _c('i', [_vm._v("Intelligencer")]), _vm._v(", December 7, 2018, "), _c('a', {
    attrs: {
      "href": "http://nymag.com/intelligencer/2018/12/andrew-sullivan-americas-new-religions.html",
      "target": "_blank"
    }
  }, [_vm._v("http://nymag.com/intelligencer/2018/12/andrew-sullivan-americas-new-religions.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". John Gray, "), _c('i', [_vm._v("Seven Types of Atheism")]), _vm._v(" (New York: Farrar, Straus & Giroux, 2018), 36")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Malcolm X and Alex Haley, "), _c('i', [_vm._v("The Autobiography of Malcolm X")]), _vm._v(" (1964; repr., New York: Ballantine Books, 2015), 224.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Justin Martyr, "), _c('i', [_vm._v("Dialogue with Trypho")]), _vm._v(", 80, Ante-Nicene Fathers, ed. Alexander Roberts and James Donaldson (1885; repr., Peabody, MA: Hendrickson, 1996).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9d0f694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 75
// module chunks = 0